import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { Link, useLocation } from 'react-router';

import { colors, spacing, typo, paperSx, primaryButtonSx } from '../../theme/tokens';

/**
 * 404 page — rendered by the catch-all route when a URL doesn't match any
 * known pattern. Works both unauthenticated (outside ProtectedRoute) and
 * within a tenant context, so it's kept free of tenant-scoped state.
 */
const NotFound: React.FC = () => {
  const location = useLocation();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.bgPage,
        p: spacing.xxxl,
      }}
    >
      <Paper elevation={0} sx={{ ...paperSx, maxWidth: 560, width: '100%', mb: 0 }}>
        <Typography sx={{ ...typo.pageTitle, mb: spacing.lg }}>Page not found</Typography>
        <Typography sx={{ ...typo.bodyText, color: colors.textSecondary, mb: spacing.lg }}>
          We couldn't find a page for{' '}
          <Box component="code" sx={{ ...typo.mono }}>
            {location.pathname}
          </Box>
          . It may have been moved, renamed, or never existed.
        </Typography>
        <Button component={Link} to="/" variant="contained" disableElevation sx={primaryButtonSx}>
          Back to tenant picker
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFound;
